<template>
    <div :class="['search-locator-search', { 'loading': isStatus('loading') }]">
        <slot :items="items">
            <button class="btn btn-primary" @click="$emit('toggle')">Toggle</button>
        </slot>
    </div>
</template>

<script>
import { withStatus } from '@cherrypulp/vue-utils';

export default {
    mixins: [ withStatus() ],

    props: {
        items: {
            default() {
                return [];
            },
            type: Array,
        },
    },

    data() {
        return {
        };
    },

    mounted() {
        this.setStatus('ready', true);
    },
};
</script>
